"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScatterPlotSeries = void 0;
// (C) 2020-2021 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var common_1 = require("../_util/common");
function getScatterPlotSeries(dv, 
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
stackByAttribute, colorStrategy) {
    var primaryMeasuresBucketEmpty = dv.def().isBucketEmpty(sdk_ui_1.BucketNames.MEASURES);
    var secondaryMeasuresBucketEmpty = dv.def().isBucketEmpty(sdk_ui_1.BucketNames.SECONDARY_MEASURES);
    var data = dv
        .rawData()
        .twoDimData()
        .map(function (seriesItem, seriesIndex) {
        var values = seriesItem.map(function (value) {
            return common_1.parseValue(value);
        });
        return {
            x: !primaryMeasuresBucketEmpty ? values[0] : 0,
            y: !secondaryMeasuresBucketEmpty ? (primaryMeasuresBucketEmpty ? values[0] : values[1]) : 0,
            name: stackByAttribute ? stackByAttribute.items[seriesIndex].attributeHeaderItem.name : "",
        };
    });
    return [
        {
            turboThreshold: 0,
            color: colorStrategy.getColorByIndex(0),
            legendIndex: 0,
            data: data,
            seriesIndex: 0,
        },
    ];
}
exports.getScatterPlotSeries = getScatterPlotSeries;
//# sourceMappingURL=scatterPlotSeries.js.map